module.exports = __webpack_public_path__ + "img/icons.ddd8405e.svg";